export default __webpack_public_path__ + "static/media/pof-card.122d041c.png";